<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      border
      resizable
      auto-resize
      show-overflow
      highlight-hover-row
      :height="500"
      :data="data"
      :loading="loading"
      :columns="tableColumns"
      :checkbox-config="{ highlight: true, trigger: 'row' }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
    </vxe-grid>
  </div>
</template>

<script>
import tableColumns from './table-columns'

export default {
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    containers: { type: Array, default: () => [] },
  },
  data() {
    return { data: [], loading: false, tableColumns: tableColumns(this) }
  },
  watch: {
    containers() {
      this.setDefaultChecked()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .ecomShipmentBookingContainerOptionsApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return

      this.data = res.body?.data || []
      this.setDefaultChecked()
    },
    setDefaultChecked() {
      const selectedCodes = new Set(
        this.containers.map((c) => c.shipmentContainerCode)
      )
      this.$nextTick(() => {
        if (!this.$refs.table) return
        this.data.forEach((row) => {
          this.$refs.table.setCheckboxRow(
            row,
            selectedCodes.has(row.shipmentContainerCode)
          )
        })
        const preChecked = this.data.filter((row) =>
          selectedCodes.has(row.shipmentContainerCode)
        )
        this.$emit('checkbox-change', preChecked)
      })
    },
    checkboxChange({ records }) {
      this.$emit('checkbox-change', records)
    },
  },
}
</script>
